import dotProp from 'dot-prop-immutable';

import { SPORT_PRODUCTS } from 'shared/constants/AppConstants';

import * as types from '../actionTypes';

const defaultState = {
  atgCalendar: {
    resolved: [],
    timestamp: null,
    isLoading: false,
    isSectionVisible: true,
    isListVisible: false,
    error: null,
  },
  sportCalendar: {
    resolved: [],
    timestamp: null,
    isLoading: false,
    isSectionVisible: true,
    isListVisible: false,
    error: null,
  },
  atgJackpots: {
    resolved: [],
    timestamp: null,
    isLoading: false,
    error: null,
  },
  sportJackpots: {
    resolved: [],
    timestamp: null,
    isLoading: false,
    error: null,
  },
  sportAnalysis: {
    OVERODDS: {
      resolved: [],
      timestamp: null,
      isLoading: false,
      error: null,
    },
    JOKER_SPORT: {
      resolved: [],
      timestamp: null,
      isLoading: false,
      error: null,
    },
  },
};

const sortBetTypes = arr => {
  const order = [
    'V75',
    'V86',
    'GS75',
    'V65',
    'V64',
    'V5',
    'V4',
    'V3',
    'T',
    'DD',
    'LD',
  ];

  return [...arr].sort(
    (a, b) => order.indexOf(a.betType) - order.indexOf(b.betType),
  );
};

const setLoading = (state, path, action) =>
  dotProp.set(state, path, props => ({
    ...props,
    isLoading: !action.error,
    error: action.error ? action.error : null,
  }));

const setResolved = (state, path, data) =>
  dotProp.set(state, path, props => ({
    ...props,
    resolved: data,
    timestamp: Date.now(),
    isLoading: false,
    error: null,
  }));

const setError = (state, path, error) =>
  dotProp.set(state, path, props => ({
    ...props,
    isLoading: false,
    error,
  }));

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    // UI changes
    case types.CHANGE_SPORT_SECTION_VISIBILITY:
      return dotProp.set(
        state,
        'sportCalendar.isSectionVisible',
        action.payload,
      );

    case types.CHANGE_ATG_SECTION_VISIBILITY:
      return dotProp.set(state, 'atgCalendar.isSectionVisible', action.payload);

    case types.CHANGE_ATG_LIST_VISIBILITY:
      return dotProp.set(state, 'atgCalendar.isListVisible', action.payload);

    case types.CHANGE_SPORT_LIST_VISIBILITY:
      return dotProp.set(state, 'sportCalendar.isListVisible', action.payload);

    // ATG calendar
    case types.REQUEST_ATG_CALENDAR:
      return setLoading(state, 'atgCalendar', action);

    case types.RECEIVE_ATG_CALENDAR: {
      const raceDays = action.payload.raceDays.map(day => ({
        ...day,
        betTypes: sortBetTypes(day.betTypes),
      }));
      return setResolved(state, 'atgCalendar', raceDays);
    }
    case types.RECEIVE_ATG_CALENDAR_ERROR:
      return setError(state, 'atgCalendar', action.payload);

    // Sport calendar
    case types.REQUEST_SPORT_CALENDAR:
      return setLoading(state, 'sportCalendar', action);

    case types.RECEIVE_SPORT_CALENDAR: {
      const { events = [] } = action.payload;
      return setResolved(
        state,
        'sportCalendar',
        events.filter(
          ({ isOpen, product }) => isOpen && SPORT_PRODUCTS.includes(product),
        ),
      );
    }

    case types.RECEIVE_SPORT_CALENDAR_ERROR:
      return setError(state, 'sportCalendar', action.payload);

    // ATG jackpots
    case types.REQUEST_ATG_JACKPOTS:
      return setLoading(state, 'atgJackpots', action);

    case types.RECEIVE_ATG_JACKPOTS:
      return setResolved(state, 'atgJackpots', action.payload);

    case types.RECEIVE_ATG_JACKPOTS_ERROR:
      return setError(state, 'atgJackpots', action.payload);

    // Sport jackpots
    case types.REQUEST_SPORT_JACKPOTS:
      return setLoading(state, 'sportJackpots', action);

    case types.RECEIVE_SPORT_JACKPOTS:
      return setResolved(state, 'sportJackpots', action.payload);

    case types.RECEIVE_SPORT_JACKPOTS_ERROR:
      return setError(state, 'sportJackpots', action.payload);

    // Sport analysis
    case types.REQUEST_SPORT_ANALYSIS:
      return setLoading(state, `sportAnalysis.${action.meta.site}`, action);

    case types.RECEIVE_SPORT_ANALYSIS:
      return setResolved(
        state,
        `sportAnalysis.${action.meta.site}`,
        action.payload,
      );

    case types.RECEIVE_SPORT_ANALYSIS_ERROR:
      return setError(
        state,
        `sportAnalysis.${action.meta.site}`,
        action.payload,
      );

    default:
      return state;
  }
}
